import { PersonRequest } from "@plinknz/tah-website-elements";

import { personalDetailsConfig } from "../config-generics/personal-details";
import { SurveyConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { confirmationConfig } from "./confirmation";
import { deliveryConfig } from "./delivery";
import { docsConfig } from "./docs";
import { financialConfig } from "./financial";
import { introConfig } from "./intro";
import { outcomesConfig } from "./outcomes";
import { participationConfig } from "./participation";

export const createSurveyConfig = (member: PersonRequest): SurveyConfig => {
  const personalConfig = personalDetailsConfig(member);

  return {
    pages: [
      ...personalConfig,
      ...introConfig,
      ...outcomesConfig,
      ...participationConfig,
      ...deliveryConfig,
      ...financialConfig,
      ...docsConfig,
      ...confirmationConfig,
    ],
  };
};
